import { FC } from 'react';
import { Divider, Tag, Typography } from 'antd';
import { TbWorldBolt } from 'react-icons/tb';

import { EmptySection, VirtualizedList as List, OurDocsLink, PlatformAlert } from '@/shared';
import { BaseSkeleton } from '@/shared/components/skeletons';
import { useConnectedAccountStore } from '@/stores';
import { ConnectedAccount } from '@/types';

import ConnectedAccountListItem from './ConnectedAccountListItem';

// interface ExistingAccountIntegrationsProps {}

const ExistingAccountIntegrations: FC = ({}): JSX.Element => {
    const { connectedAccounts, loading } = useConnectedAccountStore();

    return (
        <>
            <Divider style={{ marginTop: '1rem' }} />
            <Typography.Title id='settings-account-general-existing-integrations' level={5}>
                <TbWorldBolt style={{ verticalAlign: '-0.125rem', marginRight: '0.375rem' }} />
                Existing Integrations
                <Tag
                    style={{
                        verticalAlign: '0.05rem',
                        marginLeft: '0.5rem',
                        fontWeight: 'normal',
                        borderColor: 'transparent',
                    }}
                >
                    {connectedAccounts?.length ?? 0}
                </Tag>
            </Typography.Title>
            {connectedAccounts?.length !== 0 && !loading ? (
                <>
                    <PlatformAlert
                        status='warning'
                        title='Disconnect integrations carefully'
                        styles={{ margin: '1rem 0' }}
                        description={
                            <>
                                If you decide to disconnect one of your Connected Accounts, we also recommend removing
                                it from the third-party service's integration settings. Learn more about this in{' '}
                                <OurDocsLink />
                            </>
                        }
                    />
                    <List
                        dataSource={connectedAccounts}
                        renderItem={(i: ConnectedAccount) => {
                            return <ConnectedAccountListItem key={i?.id} i={i} />;
                        }}
                    />
                </>
            ) : (
                loading && <BaseSkeleton active title round paragraph={{ rows: 6 }} />
            )}
            {!loading && connectedAccounts?.length === 0 && (
                <EmptySection
                    description='Connect a data source to see it listed here.'
                    height='12rem'
                    icon={<TbWorldBolt />}
                    label='No Existing Integrations'
                />
            )}
        </>
    );
};

export default ExistingAccountIntegrations;
